import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/* ------------------------------------------------------------------ */
/* Festivos (holidays)                                                  */
/* ------------------------------------------------------------------ */
export const getHolidays = async () => {
  const { data } = await axios.get(`${API_URL}/holidays/all`);
  return data;
};

export const createHoliday = async (holiday) => {
  const { data } = await axios.post(`${API_URL}/holidays/create`, holiday);
  return data;
};

export const updateHoliday = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/holidays/update/${id}`, payload);
  return data;
};

export const deleteHoliday = async (id) => {
  const { data } = await axios.delete(`${API_URL}/holidays/delete/${id}`);
  return data;
};

/* ------------------------------------------------------------------ */
/* Recargos y multiplicadores (payroll-config)                         */
/* ------------------------------------------------------------------ */
export const getPayrollConfigs = async () => {
  const { data } = await axios.get(`${API_URL}/payroll-config/all`);
  return data;
};

export const updatePayrollConfig = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/payroll-config/update/${id}`, payload);
  return data;
};

export const initializePayrollConfigs = async () => {
  const { data } = await axios.post(`${API_URL}/payroll-config/initialize`);
  return data;
};

/* ------------------------------------------------------------------ */
/* Firmas (imágenes para los documentos del módulo)                    */
/* ------------------------------------------------------------------ */
export const getFirmas = async () => {
  const { data } = await axios.get(`${API_URL}/firmas/all`);
  return data;
};

export const createFirma = async (firma) => {
  const { data } = await axios.post(`${API_URL}/firmas/create`, firma);
  return data;
};

export const updateFirma = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/firmas/update/${id}`, payload);
  return data;
};

export const deleteFirma = async (id) => {
  const { data } = await axios.delete(`${API_URL}/firmas/delete/${id}`);
  return data;
};

// La imagen se sube aparte del CRUD: primero se sube el archivo, se recibe la
// URL de Cloudinary y esa URL es la que se guarda junto con nombre y cargo.
export const uploadFirmaImagen = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post(`${API_URL}/firmas/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

/* ------------------------------------------------------------------ */
/* Configuración general de la empresa                                 */
/* ------------------------------------------------------------------ */
export const getConfiguracionEmpresa = async () => {
  const { data } = await axios.get(`${API_URL}/configuracion-empresa`);
  return data;
};

export const updateConfiguracionEmpresa = async (payload) => {
  const { data } = await axios.patch(`${API_URL}/configuracion-empresa`, payload);
  return data;
};

export const uploadLogoEmpresa = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post(`${API_URL}/configuracion-empresa/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};